import React from "react";
import { WorkingHoursSection } from "../../data/sections/WorkingHoursSection"; 

const WorkingHours = ({ country }) => {
  const fetchWorkingHours = country
    ? WorkingHoursSection.countries.find(
        (c) =>
          c.country.replace(/\s+/g, "-").toLowerCase() ===
          country.replace(/\s+/g, "-").toLowerCase()
      )
    : null;

  if (!fetchWorkingHours) {
    return <p>Country not found or data not available.</p>;
  }

  const { details, section } = fetchWorkingHours;

  return (
    <div className="working-hours-container">
      <h3>{section}</h3>
      <table className="details-table">
        <tbody>
          {Object.entries(details).map(([key, value], index) => (
            <React.Fragment key={index}>
              {Object.entries(value).map(([innerKey, innerValue], idx) => (
                <tr key={idx}>
                  <td colSpan={5}><h5>{formatKey(innerKey)}:</h5></td>
                  <td>{formatValue(innerValue)}</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Utility function to format keys
const formatKey = (key) => {
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const formatValue = (value) => {
  if (typeof value === "object" && !Array.isArray(value)) {
    return (
      <ul>
        {Object.entries(value).map(([key, subValue]) => (
          <li key={key}>
            <strong>{formatKey(key)}:</strong> {formatValue(subValue)}
          </li>
        ))}
      </ul>
    );
  }

  if (Array.isArray(value)) {
    return (
      <ul>
        {value.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  }

  return value;
};

export default WorkingHours;
